export const countries = [
  { value: "852", label: "+852" },
  { value: "853", label: "+853" },
  { value: "86", label: "+86" },
];

// export const channelLists = [
//   { value: 72, label: "Samsung Online Shop | Samsung 網上商店  " },
//   {
//     value: 78,
//     label: "Samsung Experience Store (Central) | 三星專門店 (中環)  ",
//   },
//   {
//     value: 40,
//     label: "Samsung Experience Store (Tsim Sha Tsui) | 三星專門店 (尖沙咀)    ",
//   },
//   {
//     value: 42,
//     label: "Samsung Experience Store (Kowloon Bay) | 三星專門店 (九龍灣)",
//   },
//   {
//     value: 75,
//     label: "Samsung Experience Store (Tsuen Wan) | 三星專門店 (荃灣)  ",
//   },
//   { value: 39, label: "Samsung Experience Store (Shatin) | 三星專門店 (沙田)" },
//   {
//     value: 82,
//     label: "Samsung Experience Store (Tseung Kwan O) | 三星專門店 (將軍澳)    ",
//   },
//   {
//     value: 83,
//     label: "Samsung Experience Store (Yuen Long) | 三星專門店 (元朗)  ",
//   },
// ];

// export const channelListIdValidation = [72, 78, 40, 42, 75, 39, 82, 83];

export const channelLists = [
  { value: 61, label: "CSL, 1010, HKT " },
  {
    value: 10,
    label: "3HK | 3香港",
  },
  {
    value: 16,
    label: "Smartone | Smartone 數碼通",
  },
  {
    value: 63,
    label: "CMHK | 中國移動香港",
  },
  {
    value: 57,
    label: "Sun Mobile | 電訊數碼, Sun Mobile",
  },
  { value: 17, label: "Broadway | 百老匯" },
  { value: 24, label: "Fortress | 豐澤" },
  {
    value: 33,
    label: "Wilson | 衛訊",
  },
  {
    value: 18,
    label: "Chung Yuen  | 中原",
  },
  {
    value: 21,
    label: "CMK Electrical Store  | CMK張毛記",
  },
  {
    value: 31,
    label: "Suning | 蘇寧",
  },
  {
    value: 999,
    label: "Others | 其他",
  },
  {
    value: 64,
    label: "CT Macau | 中國移動澳門",
  },
  {
    value: 60,
    label: "3Macau (Macau) | 3澳門 (澳門)",
  },
  {
    value: 66,
    label: "China Telecom Macau (Macau) | 中國電信(澳門)",
  },
  {
    value: 13,
    label: "CTM (Macau) | 澳門電訊 (澳門)",
  },
];

export const channelListIdValidation = [
  61,
  10,
  16,
  63,
  57,
  17,
  24,
  33,
  18,
  21,
  31,
  999,
  64,
  60,
  66,
  13,
];
